export interface MarketplaceAuctionContactDetails {
  seller_display_name: string;
  seller_email: string;
  seller_location: string;
}
